import Vue from 'vue';
import AppSegmentations from '@/plugins/graphql/queries/v2/app-segmentations-basic.gql';
import { AppSegmentationBasicModel } from '@/helpers/entities/models/AppSegmentationBasicModel';
export default Vue.extend({
    apollo: {
        appSegmentations: {
            query: AppSegmentations,
            // Issue on cache when switching tabs;
            // workaround in progress
            fetchPolicy: 'cache-and-network',
            variables() {
                return {
                    appUuid: this.appUuid,
                };
            },
            update(data) {
                const node = (segment) => {
                    return new AppSegmentationBasicModel(segment.node);
                };
                return data.appSegmentations.edges.map(node);
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            appSegmentations: null,
            selected: null,
        };
    },
    computed: {
        selectedUuid() {
            const { selected } = this;
            if (selected) {
                return selected.uuid;
            }
            return null;
        },
        selectedName() {
            const { selected } = this;
            if (selected) {
                return selected.name;
            }
            return 'All';
        },
        appSegmentationsForSelection() {
            let selections = [new AppSegmentationBasicModel({ name: 'All', uuid: null })];
            if (this.appSegmentations) {
                selections = [...selections, ...this.appSegmentations];
            }
            return selections;
        },
    },
    methods: {
        select(segment) {
            this.selected = segment;
        },
        isSelected(segment) {
            return this.selected === segment;
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            return this.$scopedSlots.default({
                appSegmentations: this.appSegmentationsForSelection,
                selected: this.selected,
                select: this.select,
                selectedUuid: this.selectedUuid,
                selectedName: this.selectedName,
                isSelected: this.isSelected,
            });
        }
    },
});
